import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ParentComponentApi } from '../profile.component';
import { ProfileService } from '../../../services/profile.service';
import { CommondocumentsService, preCommonDocumentsInfo, Documents, UsertDetailsStatus } from '../../../services/commondocuments.service'
import { Configuration } from '../../../../app.constants';
import { HelperService } from '../../../../shared/services/helper.service';
import { DxPopupComponent } from 'devextreme-angular';
import { ImageUploadService } from '../../../../shared/services/image-upload.service';
import {Router} from '@angular/router';
import {DashboardService, PreStudentInformationDashBoard,Hallticket} from '../../../services/dashboard.service';

@Component({
  selector: 'commondocuments',
  templateUrl: './commondocuments.component.html',
  styleUrls: ['./commondocuments.component.scss']
})
export class CommondocumentsComponent implements OnInit {
  @ViewChild("dxPopUpVar") dxPopup: DxPopupComponent;
  @Input() parentApi: ParentComponentApi;
  @Input() index: any;
  columns: any;
  dataSource: any;
  commonDocument: any;
  Documents: Documents[];
  customObj: any;
  SaveBtnDisabled: boolean=false;
  StudentDocumentsData: preCommonDocumentsInfo;
  PreStudentDocuments: preCommonDocumentsInfo;
  public errorMessage: string[] = new Array();
  dataTemp: any;

  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;


  //FileUpload Changes

  fileUploadErrorMessage: string;
  filesToUpload: Array<File>;
  selectedFileNames: string[] = [];
  public isLoadingData: Boolean = false;
  uploadResult: any;
  res: Array<string>;
  documentId: string;

  popupVisible1 = false;
  popupVisible2 =false;
  popupVisible3 =false;
  public RemoveFileData :any;
  data1 :any;
  msg:string;
  showButtons:boolean=true;
  showButtons1:boolean;
  printdis:any;
  form1:any;
  profilelink:any;
  YesBtnDisabled:boolean=false;
  loadIndicatorVisible:boolean=false;
  CompDocs:any=[];
  PhysicalDisability: any;
  PreviousExamCategory: any;
  ReservationCategory: any;
  SpecialConsiderations:any;
  LanguageLabel: any;
  ApprovedFlag :any;
  CommonDocumentStatusFlag:any;

  constructor(private profileService: ProfileService,
    private CommondocumentsService: CommondocumentsService,
    private Configuration: Configuration,
    private dashboardService:DashboardService,
    private HelperService: HelperService, private imageService: ImageUploadService,private Router:Router) {
    this.columns = profileService.getCommonDocumentGridColumns();
  }
  getdata() { debugger;
    this.CommondocumentsService.GetPreStudentDocumentsList(this.Configuration.StudentID)
      .subscribe((data: Documents[]) => this.dataSource = data,
        error => {
          alert(error);
        },
        () => {
          if(this.dataSource.length > 0){
            //this.CompDocs = this.dataSource ;
            this.CommonDocumentStatusFlag = this.dataSource[0].CommonDocumentStatusFlag;        
            this.ApprovedFlag = this.dataSource[0].ApprovedFlag;        
             if (this.Configuration.StudentProfileLock == "Y") {
              /*  if(this.CommonDocumentStatusFlag ==  "N"  && this.ApprovedFlag ==  "N") {
                this.showButtons = true;    
               }
               else{
                this.showButtons = false;    
               } */
             }
            //else{
            //  this.showButtons = true; 
            //} 
          }
          for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].checkedValue == "Y") {
              this.dataSource[i].chk = true;
            } else {
              this.dataSource[i].chk = false;
            }
          }

         this.CommondocumentsService.GetCompDocumentsForAdmission(this.Configuration.StudentID)
          .subscribe((data: Documents[]) => this.CompDocs = data,
            error => {
              alert(error);
            },
            () => {
             
            }); 
        });

 
  }
  nextTab(i) {
    this.parentApi.callParentMethod('1', i, "commondocuments");
  }
  backTab(i) {
    this.parentApi.callParentMethod('2', i, "commondocuments");
  }

  ngOnInit() {
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    if(this.Configuration.StudentID==0){
      this.printdis=true;
    }

    if(this.Configuration.StudentID>0){
      this.printdis=false;
    this.dashboardService.getFormByStudentID(this.Configuration.StudentID)
    .subscribe((data: Hallticket[]) => this.form1 = data,
      error => {
        alert(error);
      },
      () => {
        
        this.profilelink=this.form1.Message;
      }
    );
    }
    ;
    if (this.Configuration.StudentProfileLock == "Y") {
      this.showButtons = false;   
      this.SaveBtnDisabled  =true;  
    }
    else{
      this.showButtons = true;
      this.SaveBtnDisabled  =false; 
    } 
    this.getdata();
    this.StudentDocumentsData = {
      StudentDocumentID: 0,
      StudentID: this.Configuration.StudentID,
      DocumentID: 0,
      DocumentApprovedFlag: "N",
      DocumentRemark: "",
      DocumentApprovedByID: 0,
      DeleteFlag: "N",
      CreatedLoginID: 0,
      UpdatedLoginID: 0,
      Documents: [],
    }
  }
  saveRecord() {
    for (var j = 0; j < this.CompDocs.length; j++) {
      for (var i = 0; i <  this.dataSource.length; i++) {
        if (this.CompDocs[j].DocumentID ==  this.dataSource[i].DocumentID) {
          if ( this.dataSource[i].chk == false) {
            this.HelperService.showWarningMessage("Please Upload " +  this.dataSource[i].DocumentName + "");
            return false;
          }
        }
      }
    }
    for (var i = 0; i <  this.dataSource.length; i++) {
      if (this.dataSource[i].chk == false &&  this.dataSource[i].CompOptFlag == "Y") {
        this.HelperService.showWarningMessage("Please Upload " +  this.dataSource[i].DocumentName + "");
        return false;
      }
    }
    this.CommondocumentsService.GetProfileLockStatusForAdmissionForm(this.Configuration.StudentID) //6123          
      .subscribe((data: UsertDetailsStatus[]) => {
        this.dataSource = data;
        this.getdata();
      },
        error => {
          alert(error);
        },
        () => {debugger
          if (this.dataSource[0].AddressInfoStatusFlag == "Y" &&
            this.dataSource[0].PersonalInfoIIStatusFlag == "Y" && this.dataSource[0].CommonDocumentStatusFlag == "Y" &&
            this.dataSource[0].PersonalInfoIStatusFlag == "Y" && this.dataSource[0].PhotoSignatureStatusFlag == "Y" &&
            this.dataSource[0].PrevEducationStatusFlag == "Y" && this.dataSource[0].SocialReservationStatusFlag == "Y"
          ) {
            this.popupVisible1 =true;
            this.msg="Do you want to lock your Profile?";
          
          } else {
            this.popupVisible2 =true;
            this.msg="Your Profile is incomplete can't Submit";
            return;
          }
        });
  }
  ProfilelockconfirmYes(e){
    this.YesBtnDisabled=true;
          this.CommondocumentsService.getupdateprofilelock(this.Configuration.StudentID) //6123          
          .subscribe((data: UsertDetailsStatus[]) => {
            this.dataSource = data;
            this.getdata();
            this.onSuccessProfileLock(); 
            this.YesBtnDisabled=false;
             this.popupVisible1 =false;
              this.Router.navigate(['/studentportal/dashboard']);
             // this.Router.navigate(['studentportal/courseselectioncollege']);
            },
            error => {
              alert(error);
            },
            () => {
              this.YesBtnDisabled=false;
            });
}
ProfilelockconfirmNo(){
  this.popupVisible2 =true;
  this.msg="You need to lock Profile from Dashboard before Application Form Submission";
  this.popupVisible1 =false;
}
confirmOK(){
  this.popupVisible2 =false;
  this.Router.navigate(['/studentportal/dashboard']);
}

  viewPdfDocument(data) {
    debugger
    if (data.key.DocumentPath.length > 0) {
      this.documentId = data.key.DocumentID;
      this.urlDoc = data.key.DocumentPath ;
      this.openWindow();
    }
  }
  removeDocument(data) {
    this.RemoveFileData =data;
    this.popupVisible3 = true; 
  }
  RemoveFileconfirmOK() {debugger
    this.data1 = this.RemoveFileData;
    if (this.data1.key.DocumentPath.length > 0) {
      var deleteDocument = {
        "StudentDocumentID": this.data1.key.StudentDocumentID,
        "UpdatedLoginID": this.data1.key.UpdatedLoginID,
        "StudentID": this.Configuration.StudentID,
      }
     
      this.CommondocumentsService.deleteUploadedDocument(deleteDocument)    
        .subscribe((data: UsertDetailsStatus) => {
          
          this.popupVisible3 = false; 
          this.getdata();
          this.HelperService.showSuccessMessage("File Deleted Successfully.");
        },
          error => {
            this.popupVisible3 = false; 
            alert(error);
          },
          () => {
           
          });
    }
    
  }
  
  onCloseButton() {
    this.popupVisible3 = false; 
  }
  onSuccessProfileLock() {
    this.HelperService.showSuccessMessage("Your Profile is Locked Successfully.");
    
  }
  

  popupHiding(e) {
    this.errorMessage = [];
  };

  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }


  showInfo() {
    this.popupVisible = true;
  }
  handleFileUpload(messageResponse: string) {
    this.HelperService.showSuccessMessage("File uploaded successfully.");
    this.getdata();
  }

  handleFileUploadError() {
    this.HelperService.showSuccessMessage("File upload not successful.");
  }

  onEditorPreparing(e) {
    if (e.parentType === "dataRow")
    {
      if (e.dataField === "chk")
      {
       
          e.editorOptions.readOnly = true;
        
      }
    }
  }
  profileprint(){
    this.dashboardService.getFormByStudentID(this.Configuration.StudentID)
    .subscribe((data: Hallticket[]) => this.form1 = data,
      error => {
        alert(error);
      },
      () => {
        
        this.profilelink=this.form1.Message;
      }
    );
  }
}
